import { Component, OnDestroy, OnInit } from "@angular/core";
import { ViewStateService } from "../../shared/services/view-state.service";
import { Router, ActivatedRoute } from "@angular/router";
import { AssessmentService } from "../shared/services/assessment.service";
import { UserService } from "../../shared/services/user.service";
import { NotificationsService } from "../../shared/services/notifications.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-terms-condition",
  templateUrl: "./terms-condition.component.html",
  styleUrls: ["./terms-condition.component.css"],
})
export class TermsConditionComponent implements OnInit, OnDestroy {
  assessmentId: string;
  personId: string;
  private destroy$ = new Subject<void>();

  constructor(
    private userService: UserService,
    private assessmentService: AssessmentService,
    private router: Router,
    private route: ActivatedRoute,
    private notifications: NotificationsService
  ) {}

  ngOnInit() {
    this.personId = this.userService.CurrentUser.personId;
    this.route.params.pipe(takeUntil(this.destroy$)).subscribe((params) => {
      this.assessmentId = params["assessmentId"];
    });
  }

  accept() {
    this.router.navigate(["assessment/" + this.assessmentId + "/rules/1"]);
  }

  blockCopy() {
    this.assessmentService
      .warnUser(this.personId, "copy")
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          this.notifications.errorWithWait(
            "Warning",
            "Your key strokes are recorded by the system. Efforts to capture content could initiate an investigation of potential misconduct by the NBRC Judicial and Ethics Committee.",
            0
          );
        },
        (err) => {
          console.log(err);
        }
      );
  }

  blockCut() {
    this.assessmentService
      .warnUser(this.personId, "cut")
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          this.notifications.errorWithWait(
            "Warning",
            "Your key strokes are recorded by the system. Efforts to capture content could initiate an investigation of potential misconduct by the NBRC Judicial and Ethics Committee.",
            0
          );
          console.log(res);
        },
        (err) => {
          console.log(err);
        }
      );
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
